import Avatar from '@ui-components/avatar'
import COLORS from '@web-ui-kit/colors'
import SPACES from '@web-ui-kit/spaces'
import Text from '@web-ui-kit/text'
import { styled, css } from 'styled-components'

export const CustomAvatar = styled(Avatar)`
  height: 2.5rem;
  min-width: 2.5rem;
  width: fit-content;
  ${({ $active }) =>
    $active &&
    css`
      border: 0.125rem solid ${({ theme }) => theme?.colors?.ACCENT_600};
    `}
`
export const CustomButton = styled.button`
  align-items: center;
  border-radius: 3.125rem;
  color: ${COLORS.BLACK};
  display: flex;
  gap: ${SPACES.S};
  padding: ${SPACES['2XS']} ${SPACES.XS};
  text-align: left;
  width: 100%;
  ${({ $active }) =>
    $active &&
    css`
      background-color: ${({ theme }) => theme?.colors?.ACCENT_50};
    `}
  @media (hover: hover) {
    &:hover {
      background-color: ${COLORS.NEUTRAL_100};
    }
  }
  &:disabled {
    color: ${COLORS.NEUTRAL_400};
    pointer-events: none;
    & > ${CustomAvatar} {
      border: none;
    }
  }
`

export const Info = styled.div`
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
`

export const CustomFullName = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CustomText = styled(Text)`
  color: ${COLORS.NEUTRAL_600};
`
